import React from "react";
import { TID } from "@/constants/tids";
import { Button } from "@/components/ui/button";
import { Loader2, RefreshCw, Pencil, Save, X, Trash2 } from "lucide-react";

// Toolbar for the AI Analyst report: shows Save/Cancel while editing, otherwise
// Edit / Regenerate / Clear Report. Extracted to keep AnalystReport lean.
export default function ReportToolbar({
  editing,
  saving,
  loading,
  clearing,
  onSave,
  onCancel,
  onEdit,
  onRegenerate,
  onClear,
}) {
  if (editing) {
    return (
      <div className="flex items-center gap-2">
        <Button data-testid={TID.saveReportBtn} onClick={onSave} disabled={saving} size="sm">
          {saving ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" /> Saving…
            </>
          ) : (
            <>
              <Save className="w-4 h-4 mr-2" /> Save
            </>
          )}
        </Button>
        <Button
          data-testid={TID.cancelEditBtn}
          onClick={onCancel}
          disabled={saving}
          variant="outline"
          size="sm"
        >
          <X className="w-4 h-4 mr-2" /> Cancel
        </Button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <Button data-testid={TID.editReportBtn} onClick={onEdit} variant="outline" size="sm">
        <Pencil className="w-4 h-4 mr-2" /> Edit
      </Button>
      <Button
        data-testid={TID.generateReportBtn}
        onClick={onRegenerate}
        disabled={loading}
        variant="outline"
        size="sm"
      >
        {loading ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" /> Regenerating…
          </>
        ) : (
          <>
            <RefreshCw className="w-4 h-4 mr-2" /> Regenerate
          </>
        )}
      </Button>
      <Button
        data-testid={TID.clearReportBtn}
        onClick={onClear}
        disabled={clearing || loading}
        variant="outline"
        size="sm"
        className="text-destructive hover:text-destructive"
      >
        {clearing ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" /> Clearing…
          </>
        ) : (
          <>
            <Trash2 className="w-4 h-4 mr-2" /> Clear Report
          </>
        )}
      </Button>
    </div>
  );
}
